import api from '../api/client';

const getTrail = async (appId, params = {}) => {
    const res = await api.get('/api/audit-trail', {
        params: { app_id: appId, ...params },
    });
    return res?.data?.data;
};

// Data-table adapter: useServerTable sends filter_<key>; the endpoint takes the bare names
// (action, actor_user_id, resource_type, from_date, to_date). Resolves to { results, pagination }.
const getPage = async (appId, query = {}) => {
    const params = {};
    Object.entries(query).forEach(([k, v]) => {
        params[k.startsWith('filter_') ? k.slice('filter_'.length) : k] = v;
    });
    return getTrail(appId, params);
};

const getActions = async (appId) => {
    const res = await api.get('/api/audit-trail/actions', {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

// Option lists for the filter panel: { actions, resource_types, actors: [{ user_id, username, name }] }.
const getFacets = async (appId) => {
    const res = await api.get('/api/audit-trail/facets', {
        params: { app_id: appId },
    });
    return res?.data?.data;
};

const getStats = async (appId, params = {}) => {
    const res = await api.get('/api/audit-trail/stats', {
        params: { app_id: appId, ...params },
    });
    return res?.data?.data;
};

const auditTrailService = { getTrail, getPage, getActions, getFacets, getStats };

export default auditTrailService;
